export enum Rules {
  Read = "read",
  Write = "write",
}
export enum FeatureStatus {
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
  HIDDEN = "HIDDEN",
  UNKNOWN = "UNKNOWN",
}

export interface FeatureInfo {
  rule: Rules[];
  resource: string;
  featureName: string;
  hasAccess: boolean;
  featureStatus: FeatureStatus;
  hasAllRegions: boolean;
  lstRegionGuids: string[] | null;
  lotAreaLimit_m2: number[] | null;
}

export interface ProcessEnv {
  [key: string]: any | undefined
}